import React from 'react';

const Confirmation = (props) => {
  // set as true by default
  let hasCloseButton = props.hasCloseButton !== false;

  return (
    <div className="c-confirmation">
      {hasCloseButton ? (
        <a href={props.link}>
          <span className="show-for-sr">Stäng</span>
        </a>
      ) : null}
      <div className="c-confirmation__content">
        <h2>{props.heading}</h2>
        {props.children}
      </div>
    </div>
  );
};

export default Confirmation;
